import { Box, Typography, Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { handleSetShowMap } from "../../store/actions/uiActions/myPermitsActions";
import React from "react";

const ShowMapSwitch = () => {
  const { showMap } = useSelector((state) => state.myPermitsComponent.duvalMap);

  const dispatch = useDispatch();

  const onChange = (event) => {
    const isMap = event.target.checked;

    dispatch(handleSetShowMap(isMap));
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography fontWeight="bold" variant="body2">
        NOC Form
      </Typography>
      <Switch checked={showMap} onChange={onChange} />
      <Typography fontWeight="bold" variant="body2">
        Map View
      </Typography>
    </Box>
  );
};

export default React.memo(ShowMapSwitch);
